// extracted by mini-css-extract-plugin
export default {"embeddedWrapper":"style_embeddedWrapper__8t1Ea"};